import { type JSX, Show } from 'solid-js';

/**
 * Sticky full-width page header with an iOS-style liquid-glass background.
 * Render it as the first child of the page (outside the max-w content
 * container); the inner wrapper aligns the title with the max-w-6xl column.
 */
export const PageHeader = (props: {
  title: JSX.Element;
  /** Badge row / subtitle rendered under the title. */
  sub?: JSX.Element;
  /** Right-aligned buttons/links. */
  actions?: JSX.Element;
}) => (
  <header class="sticky top-0 z-10 border-b border-neutral-200/70 bg-white/95 backdrop-blur-xl backdrop-saturate-150 supports-[backdrop-filter]:bg-white/65 dark:border-neutral-800/70 dark:bg-neutral-950/95 dark:supports-[backdrop-filter]:bg-neutral-950/65">
    <div class="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
      <div class="min-w-0">
        <h1 class="text-lg font-semibold">{props.title}</h1>
        <Show when={props.sub}>
          <div class="mt-1 text-sm text-neutral-500">{props.sub}</div>
        </Show>
      </div>
      <Show when={props.actions}>
        <div class="flex shrink-0 items-center gap-2">{props.actions}</div>
      </Show>
    </div>
  </header>
);
